
import FilterPager from './components/FilterPager/FilterPager'
import verifyLabel from '../../../methods/verifyLabel'
export default {
    name: 'shop-filter',
    data(){
        return {
            searchConfig: {
                skip: 0,
                take: 1,
                puid: '22ae6b81-0a19-4d91-ade0-79b86f870ecb',
                language: "da"
            },
            selectedFacets: {},
            demo: false,
            displayFilters: false,
        }
    },
    computed: {
        categories(){
            return this.$store.state.search.categories 
        },
        selectedFacetsFromResponse(){
            return this.$store.state.search.selectedFacets
        },
        tabletSizeBreakpoint() {
            return (window.screen.width <= 1080)
        }
    },
    methods: {
        selectFilter(key,value){

            const flushMatchingProductGroups = (groupList)=>{

                groupList.forEach(groupName => {
                    const groupExists = !!this.selectedFacets[groupName]

                    if(groupExists){
                        this.selectedFacets[groupName] = []
                    }
                })

            }

            const selection = this.selectedFacets[key]

            const ProductTypeMappedToRelatedGroups = {
                ProductTypeSoftware : ['ProductGroupSoftware'],
                ProductTypeHardware: ['ProductGroupHardware'],
                ProductTypeCourse: ['ProductGroupCourse','CourseLevel','Location']
            }

            const matchingGroupList = ProductTypeMappedToRelatedGroups[key]

            if(selection && (selection.indexOf(value) > -1)){
                this.selectedFacets[key] = this.selectedFacets[key].filter(alreadyKnown => alreadyKnown !== value) // value already exists = remove it
                if(matchingGroupList){
                    flushMatchingProductGroups(matchingGroupList)
                }
            } else if(selection) {
                this.selectedFacets[key].push(value) // add value to existing array
            } else {
                this.selectedFacets[key] = [value] // add new array with value
            }

            const selectedFacetsForStore = Object.assign({},this.selectedFacets,this.selectedFacetsFromResponse)

            const newSearchConfig = Object.assign({},this.$store.state.search.searchConfig,{skip:0})

            this.$store.commit('search/setSelectedFacets',selectedFacetsForStore)
            this.$store.commit('search/setSearchConfig',newSearchConfig)
            this.$store.dispatch('search/performSearch')

            this.selectedFacets = {} // hard reset
        },
        toggleFilters() {
            if (this.displayFilters) {
                this.displayFilters = false
            } else {
                this.displayFilters = true
            }
        },
        clearFilters() {
            const newSearchConfig = Object.assign({},this.$store.state.search.searchConfig,{skip:0})

            this.$store.commit('search/setSelectedFacets',{})
            this.$store.commit('search/setSearchConfig',newSearchConfig)
            this.$store.dispatch('search/performSearch')
        },
        displayDemo(){
            this.demo = !this.demo
        },
        verifyLabel(displayName) {
            if (this.$store.state.main.labels) {
                return verifyLabel(displayName,this.$store.state.main.labels)
            } else {
                return ""
            }
        }
    },
    mounted(){
        this.$store.dispatch('search/performSearch',this.searchConfig)
    },
    watch: {
        selectedFacetsFromResponse(newFacets){
            this.selectedFacets = newFacets
        }
    },
    components: {
        FilterPager
    }
}